var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscipline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "discipline",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 51 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.59,34.69c1.12,5.86,5.52,9.31,5.52,9.31h17.25c0,0,4.4-3.45,5.52-9.31H11.59z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.13,21.92v-9.01c0-0.61,0.25-1.19,0.69-1.62l3.78-3.62C16.05,7.24,16.65,7,17.27,7h17.05 c0,0,1.9,0.43,1.9,3.06s-1.77,2.93-1.77,2.93H16.39c0,0-2.41,0.47-2.41,2.67S13.97,19.46,11.13,21.92z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.31,20.73h0.02c0-5.66-3.74-5.66-3.74-5.66H19.9c0,0-3.74,0-3.74,5.66h-0.01c0,0-4.56,3.23-4.56,10.35 h28.29C39.87,23.49,35.31,20.73,35.31,20.73z M21.85,28.37h-2.59v-2.59h2.59V28.37z M21.85,23.2h-2.59v-2.59h2.59V23.2z M27.02,28.37h-2.59v-2.59h2.59V28.37z M27.02,23.2h-2.59v-2.59h2.59V23.2z M32.2,28.37h-2.59v-2.59h2.59V28.37z M32.2,23.2h-2.59 v-2.59h2.59V23.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscipline);
export default __webpack_public_path__ + "static/media/discipline.d2ed61d38c9c0067f0e40b6a9793e0a3.svg";
export { ForwardRef as ReactComponent };